import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  setPersistence,
  browserSessionPersistence,
  signOut,
  updatePassword,
} from 'firebase/auth'
import logScope from 'log-scope'
import httpService from '@/services/httpService'

const log = logScope('Auth')
const auth = {
  isLoggedIn: false,
  userId: null,
}

const fbAuth = getAuth()

auth.init = function () {
  log.success('Initializing...')

  /* Callback to update loged in. Had some bugs, so uses the long way to check if getUser === null
  // Init admin tools
  auth.onAuthStateChanged(() => {
    const user = auth.getUser()
    this.isLoggedIn = user !== null

    if (this.isLoggedIn) {
      log.success('Is logged in')
    }
  })
  */
}

auth.onAuthStateChanged = async callback => {
  await onAuthStateChanged(fbAuth, async user => {
    log.debug('Auth state change')
    callback()
  })
}

auth.getUser = function () {
  const user = fbAuth.currentUser
  this.userId = user ? user.uid : null
  return user
}

auth.getRefreshsedUser = () => new Promise((resolve) => {
  const user = fbAuth.currentUser
  user.reload().then(() => {
    const refreshUser = fbAuth.currentUser
    resolve(refreshUser)
  })
})

auth.setSessionMode = async () => {
  log.debug('Set session mode')
  await setPersistence(fbAuth, browserSessionPersistence)
}

auth.logout = async () => {
  log.debug('logout user')
  await signOut(fbAuth)
}

auth.sendPasswordResetEmail = async (email) => {
  await sendPasswordResetEmail(fbAuth, email)
}

auth.signOut = async () => {
  log.debug('Sign out')
  await signOut(fbAuth)
}

auth.loginAsync = async (email, password) => {
  try {
    await signInWithEmailAndPassword(fbAuth, email, password)
    return
  } catch (err) {
    let msg = 'Okänt fel vid inloggning'
    if (err.code) {
      switch (err.code) {
        case 'auth/invalid-email':
        case 'auth/argument-error':
          msg = 'Ogiltig email'
          break
        case 'auth/user-not-found':
          msg = 'Ingen användare hittades'
          break
        case 'auth/wrong-password':
          msg = 'Felaktigt lösenord'
          break
        case 'auth/too-many-requests':
          msg = 'Du har försökt för många gånger. Vänta en stund'
          break
      }
    }
    log.error(err)
    throw new Error(msg)
  }
}

auth.changeUserPasswordAsync = async (
  email,
  oldPw,
  newPw,
  newPwConf
) => {
  try {
    if (newPw !== newPwConf) {
      throw new Error('De nya lösenorden stämmer inte överens')
    }
    await signInWithEmailAndPassword(fbAuth, email, oldPw)

    const user = fbAuth.currentUser

    await updatePassword(user, newPw)
  } catch (err) {
    let msg = err.message || 'Okänt fel vid ändring av lösenord'
    if (err.code) {
      switch (err.code) {
        case 'auth/invalid-email':
          msg = 'Kunde ej logga in. Felaktig email.'
          break
        case 'auth/invalid-password':
          msg = 'Nuvarande lösenord är inkorrekt.'
          break
        case 'auth/wrong-password':
          msg = 'Nuvarande lösenord är inkorrekt eller saknas.'
          break
        case 'auth/weak-password':
          msg = 'Nytt lösenord måste vara minst 8 karaktärer samt en siffra/symbol.'
          break
        case 'auth/too-many-requests':
          msg = 'Det har skett förmånga försök för detta konto. Vänligen vänta några minuter eller byt lösenord.'
          break
      }
    }
    log.error(err)
    throw new Error(msg)
  }
}

auth.registerAsync = async (user) => {
  const qs = require('qs')

  try {
    const params = {
      url: 'registerAsync',
      data: qs.stringify(user),
      retry: false,
    }

    const response = await httpService.post(params)
    return response.data
  } catch (err) {
    let msg = err.message || 'Okänt fel'
    if (err.response) {
      const customError = err.response.data
      if (customError.includes('id[10]')) {
        msg = 'E-posten används redan. Om du är kund, vänligen logga in.'
      } else if (customError.includes('id[11]')) {
        msg =
          'Personnummret är redan kopplat till oss. Om du är kund, vänligen logga in.'
      } else {
        msg = 'Serverfel, kontakta oss om felet uppstår igen.'
      }
    }
    log.error(err)
    throw new Error(msg)
  }
}

export default auth
